import React from "react";
import "./index.scss";
import apropo1 from "../../assets/apropo1.png";
import apropo2 from "../../assets/apropo2.png";
import apropo3 from "../../assets/apropo3.png";
import apropo4 from "../../assets/apropo4.png";
import StickyButton from "../StickyButton";
const ApropoHome = () => {
  const cards = [
    { id: 1, image: apropo4, title: "Accès à l’eau potable" },
    {
      id: 2,
      image: apropo3,
      title: "Lutte contre l’insécurité alimentaire",
    },
    { id: 3, image: apropo2, title: "Aide humanitaire d’urgence" },
    {
      id: 4,
      image: apropo1,
      title: "Accès à l’éducation",
      highlight: true,
    },
  ];

  return (
    <section className="section-container-propo">
      {/* Div en haut avec les titres */}
      <div className="top-con">
        <div className="top-content-propo">
          <h3 className="small-title-propo">JM Foundation</h3>
          <h1 className="big-title-propo">Qui Sommes Nous ?</h1>
          <p className="text-title-propo">
            La Fondation Junior MBUYI améliore les conditions de vie en milieu
            rural en fournissant vivres et infrastructures. Elle redonne espoir,
            dignité et autonomie aux populations souvent oubliées.
          </p>
        </div>
        <StickyButton />
      </div>

      <section className="card-section">
        {cards.map((card) => (
          <div className="card-rect">
            <div key={card.id} className={`card-apropo`}>
              <img src={card.image} alt={card.title} className="card-image" />
              <div className="card-content">
                <p>{card.title}</p>
              </div>
            </div>{" "}
            <div className={` ${card.highlight ? "highlight-card" : ""}`}></div>
          </div>
        ))}
      </section>
    </section>
  );
};

export default ApropoHome;
